module.exports = __webpack_public_path__ + "img/avto-shida.2ca5618e.png";